import React from 'react';
import styled from 'styled-components';

import { defaultTheme } from '../../themes/default.theme';

type Props = {
  onRetry: () => void;
  message?: string;
  compact?: boolean;
};

export const CardError: React.FC<Props> = ({
  onRetry,
  message = "Couldn't load this data",
  compact = false,
}) => {
  return (
    <Wrapper role="alert" $compact={compact}>
      <Message>{message}</Message>
      <RetryButton type="button" onClick={onRetry}>
        Retry
      </RetryButton>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $compact: boolean }>`
  display: flex;
  flex-direction: ${({ $compact }) => ($compact ? 'row' : 'column')};
  align-items: center;
  justify-content: ${({ $compact }) => ($compact ? 'flex-end' : 'center')};
  gap: 8px;
  min-height: ${({ $compact }) => ($compact ? '0' : '100px')};
  padding: ${({ $compact }) => ($compact ? '0' : '16px')};
  border: ${({ $compact }) =>
    $compact ? 'none' : `1px solid ${defaultTheme.colors.brandLightGrey}`};
  border-radius: 8px;
  background: ${({ $compact }) => ($compact ? 'transparent' : defaultTheme.colors.white)};
  font-family: Poppins;
`;

const Message = styled.div`
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
`;

const RetryButton = styled.button`
  border: none;
  background: none;
  padding: 4px 8px;
  color: ${defaultTheme.colors.brandBlue};
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${defaultTheme.colors.brandBlue};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
